<template>
  <app-header></app-header>
  <div id="app">
    <div class="wrapper section member">
      <nav-aside></nav-aside>
      <router-view :key="fullPath"></router-view>
    </div>
  </div>
  <Loading v-show="loading"></Loading>
  <app-footer></app-footer>
</template>
<script>
import NavAside from '@/components/memberCenter/Nav.vue';
import AppHeader from '@/components/Header.vue';
import AppFooter from '@/components/Footer.vue';
import router from '@/router';
import Loading from '@/components/Loading.vue';
import { getUserInfo } from '@/api/apiService';

export default {
  name: 'MemberPage',
  components: {
    'nav-aside': NavAside,
    'app-header': AppHeader,
    'app-footer': AppFooter,
    Loading,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {},
  computed: {
    fullPath() {
      return router.currentRoute.value.fullPath;
    },
    jwt() {
      return this.$store.state.jwt;
    },
  },
  mounted() {
    this.fetchUserInfo();
  },
  methods: {
    async fetchUserInfo() {
      try {
        this.loading = true;
        const userDataResponse = await getUserInfo(this.jwt, true);
        if (!userDataResponse) return;
      } catch (error) {
        console.error('Error fetching user info:', error);
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss">
@import '../assets/styles/pages/memberCenter/member.scss';
@import '../assets/styles/pages/memberCenter/ticketSection.scss';
@import '../assets/styles/pages/memberCenter/myProps.scss';
@import '../assets/styles/pages/memberCenter/serialNumber.scss';
@import '../assets/styles/pages/memberCenter/memberInformation.scss';
@import '../assets/styles/pages/memberCenter/accountSetting.scss';
@import '../assets/styles/pages/memberCenter/myOrders.scss';
</style>
